module.exports = __webpack_public_path__ + "static/media/pg25.55a5a69a.jpg";